import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const BuyReportFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": "date",
                        "name": "start",
                        "label": "Inicio",
                        "min": "2025-09-02",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4,
                            "lg": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "end",
                        "label": "Fin",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4,
                            "lg": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ]
        }
    ],
};


export default BuyReportFormConfig;